import * as React from "react";

export const MOBILE_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;

export type Breakpoint = "mobile" | "tablet" | "desktop";

function getBreakpoint(width: number): Breakpoint {
  if (width < MOBILE_BREAKPOINT) return "mobile";
  if (width < DESKTOP_BREAKPOINT) return "tablet";
  return "desktop";
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = React.useState<Breakpoint>(() =>
    typeof window === "undefined" ? "desktop" : getBreakpoint(window.innerWidth),
  );

  React.useEffect(() => {
    const onChange = () => setBp(getBreakpoint(window.innerWidth));
    window.addEventListener("resize", onChange);
    onChange();
    return () => window.removeEventListener("resize", onChange);
  }, []);

  return bp;
}

export function useIsMobile() {
  return useBreakpoint() === "mobile";
}

export function useIsTablet() {
  return useBreakpoint() === "tablet";
}

export function useIsDesktop() {
  return useBreakpoint() === "desktop";
}

export function useIsMobileOrTablet() {
  const bp = useBreakpoint();
  return bp === "mobile" || bp === "tablet";
}
